import {
    CameraType, CloseShareStatusAction, CloseWarningExceptionAction,
    ExpandLayoutListAction,
    ExpandVideoLayoutAction, OpenWarningExceptionAction,
    setCheckedPaneAction,
    ShrankVideoLayoutAction,
    ShutAlllistsAction, TriggerAboutTableAction, TriggerAcknowledgeTableAction,
    TriggerDatepickerAcion,
    TriggerExportAVIListAction,
    TriggerExportStatusAction, TriggerHelpTableAction,
    TriggerLayoutListAction,
    TriggerSpeedPickerAcion,
    ViewType,
    SetIsLoadedAction,
    SetInitialCamerasAction,
    exportWindowSizeType,
    SetExportWindowSizeAction,
    GetLayoutInfoAction,
    LayoutType,
    SetMapInfo,
    SetCurrentLayoutChangedAction,
    SetWebPageInfo
} from "./types";

import { initialLayout } from './initialState';
import { IRequestMapInfo, IRequestWebPageInfo } from "../../services/cayuga/types";

const triggerLayoutList = (openedLayoutList: boolean) : TriggerLayoutListAction => ({type: 'triggerLayoutList', openedLayoutList});

const expandLayoutList = (expandedLayoutList: boolean) : ExpandLayoutListAction => ({type: 'expandLayoutList', expandedLayoutList});

const expandVideoLayout = (expandedVideoLayout: number) : ExpandVideoLayoutAction => ({type: 'expandVideoLayout', expandedVideoLayout});

const shrankVideoLayout = () : ShrankVideoLayoutAction => ({type: 'shrankVideoLayout'});

const setCheckedPane = (pane: number) : setCheckedPaneAction => ({type: 'setCheckedPane', pane});

const shutAlllists = () : ShutAlllistsAction => ({type: 'shutAlllists'});

const triggerDatepicker = (datePickerIsOpened: boolean) : TriggerDatepickerAcion => ({type: 'triggerDatepicker', datePickerIsOpened});

const triggerSpeedPicker = (speedPickerIsOpened: boolean) : TriggerSpeedPickerAcion => ({type: 'triggerSpeedPicker', speedPickerIsOpened});

export const triggerExportAVIList = () : TriggerExportAVIListAction => ({type: 'triggerExportAviList'});

export const triggerExportStatusList = () : TriggerExportStatusAction => ({type: 'triggerExportStatusList'});

export const closeShareStatus = () : CloseShareStatusAction => ({type: 'closeShareStatus'});

export const closeWarningException = () : CloseWarningExceptionAction => ({type: 'closeWarningException'});

export const openWarningException = (message: string) : OpenWarningExceptionAction => ({type: 'openWarningException', message});

export const triggerAcknowledgeTable = (opened: boolean) : TriggerAcknowledgeTableAction => ({type: 'triggerAcknowledgeTable', opened});

export const triggerHelpTable = (opened: boolean) : TriggerHelpTableAction => ({type: 'triggerHelpTable', opened});

export const triggerAboutTable = (opened: boolean) : TriggerAboutTableAction => ({type: 'triggerAboutTable', opened});

export const setIsLoaded = (isLoaded: boolean) : SetIsLoadedAction => ({type: 'setIsLoaded', isLoaded});

export const setInitialCameras = (cameras: any[]) : SetInitialCamerasAction => ({type: 'setInitialCameras', cameras});

export const setExportWindowSize = (size: exportWindowSizeType) : SetExportWindowSizeAction => ({type: 'setExportWindowSize', size});

const setCurrentLayout = (currentLayout: {id: string, view: ViewType, layoutType: LayoutType}, activeViewPosition?: number) =>  {
    let parsedCurrentLayout;
    let currentLayoutType = 'Layer';
    if (currentLayout) {
        const { view, id, layoutType } = currentLayout;
        const { cols, rows, name, cameras } = view;
        currentLayoutType = layoutType;
        type Hashtype = {
            [propName: number]: string | null
        }

        parsedCurrentLayout = {
            id, rows, cols, name,
            // @ts-ignore
            camerasIds: cameras.reduce<Hashtype>((hash, camera, i) => {
                hash[i] = camera.id;
                return hash
            }, {}),
            panes: cameras.map((_,i) => i),
            camerasPositions: cameras.map(({relative_position}: CameraType) => {
                return {
                    left: relative_position.left * 100 + '%',
                    top: relative_position.top * 100 + '%',
                    width: (relative_position.right - relative_position.left) * 100 + '%',
                    height: (relative_position.bottom - relative_position.top) * 100 + '%'
                }
            })
        };
    } else {
        parsedCurrentLayout = initialLayout
    }

    return {
        type: 'setCurrentLayout',
        currentLayout: parsedCurrentLayout,
        currentLayoutType: currentLayoutType,
        activeViewPosition: activeViewPosition
    };
};

export const getLayoutInfo = (id: string, entityType: string, name: string, shouldChangeLayout?: Boolean, activeViewPosition?: number): GetLayoutInfoAction => ({type: 'getLayoutInfo', id, entityType, name, shouldChangeLayout, activeViewPosition});

export const setCurrentLayoutChanged = (): SetCurrentLayoutChangedAction => ({type: 'setCurrentLayoutChanged'})

export const setMapInfo = (data: IRequestMapInfo): SetMapInfo => ({type: 'setMapInfo', data});

export const setWebPageInfo = (data: IRequestWebPageInfo): SetWebPageInfo => ({type: 'setWebPageInfo', data});

export {
    triggerLayoutList,
    setCurrentLayout,
    setCheckedPane,
    shutAlllists,
    expandLayoutList,
    expandVideoLayout,
    shrankVideoLayout,
    triggerDatepicker,
    triggerSpeedPicker
}

